import { PipeTransform, Pipe } from "@angular/core";

@Pipe({ name: 'splitString' })
export class SplitStringPipe implements PipeTransform {
  transform(value: string) {
    let arrString = value.split("=>");
    return arrString[arrString.length - 1];
  }
}



// WEBPACK FOOTER //
// ./src/app/custom-pipes/split-string.pipe.ts